import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';


export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5rem;
  }

  .row-left {
    margin-bottom: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .no-margin {
    margin: 0 !important;
  }

  .header {
    padding: 0 0.6rem;
    margin-bottom: 1rem;

    .h-descricao {
      font-size: 0.7125rem;
      line-height: 0.8rem;
      color: ${Colors.Color7};
    }
  }

  .title_p {
    text-align: left;
    max-width: 100%;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1.8rem;
    margin-bottom: 0.5rem;
    color: ${Colors.Color7};
    ${props => props.row && `width: 6rem; margin-bottom: 0rem;`}
  }

  .row {

    .list-atv {
      margin-top: 1em !important;
    }

    .lateral {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      
      p {
        margin-left: 0.5rem;
      }
    }

    .no-padding {
      padding: 0 !important;
    }

    .item {

      h6 {
        text-align: left;
        max-width: 100%;
        font-weight: 600;
        font-size: 0.8rem;
        line-height: 1.8rem;
        margin-bottom: 0rem;
        color: ${Colors.Color4};
      }

      h3 {
        text-align: left;
        max-width: 100%;
        font-weight: 600;
        font-size: 1rem;
        line-height: 1.8rem;
        margin-bottom: 0.5rem;
        color: ${Colors.Color7};
      }

      h5 {
        text-align: left;
        max-width: 100%;
        font-weight: 500;
        font-size: 0.85rem;
        line-height: 1.8rem;
        margin-bottom: 0.5rem;
        color: ${Colors.Color7};
      }

      p {
        text-align: left;
        max-width: 100%;
        font-weight: 500;
        font-size: 0.85rem;
        line-height: 1.8rem;
        margin-bottom: 0.5rem;
        color: ${Colors.color25};
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    box-shadow: 0px 0px 19px 0px rgb(4 4 4 / 25%) !important;
    margin-bottom: 1.5rem;
    border-radius: 0.4rem;
    padding: 0em 1em 0em 1em !important;

    .content-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .card-cod {
        background: ${Colors.Color2};
        border-radius: 0.4rem;
        padding: 0.2em 0.6rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 31%;
        margin-top: 0.75rem;
        margin-bottom: 1.25rem;

        .cod {
          font-size: 0.75rem;
          font-weight: 500;
          color: ${Colors.Color4};
        }
      }
    }
  }

`;

export const ThisCardAtividade = styled.div`
  margin-bottom: 1.3rem;
  padding: 0.8rem;
  border-radius: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  min-height: 5.2rem;
  position: relative;
  overflow: hidden;
  background: ${Colors.Color1};

  ${props => {
    if (props?.ativo) {
      return `border: 0.1em solid ${Colors.Color8};`;
    }
  }}

  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: calc(100% - 10em);

    .content-top {
      display: flex;
      flex-direction: column;

      .card-top {
        line-height: 0.9rem;

        .titulo {
          font-size: 0.8rem;
          font-weight: bold;
          color: ${Colors.Color14};
        }

        .analista {
          white-space: pre;
          white-space: pre-line;
          white-space: pre-wrap;
          font-size: 0.7rem;
          font-weight: 600;
          color: ${Colors.Color14};
        }
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .data {
        font-size: 0.65rem;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .projeto {
        font-size: 0.65rem;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .cliente {
        font-size: 0.65rem;
        font-weight: 600;
        color: ${Colors.Color14};
      }
    }
  }

  .content-os {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 8rem;

    p {
      margin-bottom: 0em !important;
    }

    .horario {
      display: flex;
      margin-bottom: 1rem;
      align-items: flex-start;
      flex-direction: column;

      .item-hora {
        display: flex;
        margin-bottom: 0.6rem;

        .card-numero {
          background: ${Colors.Color4};
          border-radius: 0.4rem;
          display: flex;
          flex-direction: row;
          width: 1.4rem;
          height: 1.4rem;
          justify-content: center;
          align-items: center;
          margin-left: 0.45rem;

          .numero {
            font-size: 0.7rem;
            font-weight: 600;
            color: white;
          }
        }

        .card-hora {
          background: ${Colors.Color8};
          border-radius: 0.4rem;
          padding: 0.2em 0.6rem;
          display: flex;
          flex-direction: row;
          height: 1.4rem;
          margin-left: 0.45rem;
          justify-content: center;
          align-items: center;

          .hora {
            font-size: 0.7rem;
            font-weight: 600;
            color: ${Colors.Color4};
            width: 100%;
          }
        }
      }
    }

    .totalizadores {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .desconto {
        font-size: 0.8rem;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .translado {
        font-size: 0.8rem;
        font-weight: 600;
        margin-left: 1rem;
        color: ${Colors.Color14};
      }

      .card-total {
        background: ${Colors.Color8};
        border-radius: 0.4rem;
        padding: 0.2em 0.6rem;
        display: flex;
        flex-direction: row;
        height: 1.4rem;
        margin-left: 1rem;
        justify-content: center;
        align-items: center;

        .total {
          font-size: 0.75rem;
          font-weight: bold;
          color: ${Colors.Color4};
          width: 100%;
        }
      }
    }
  }
`;
